import { render, staticRenderFns } from "./ContactsList.vue?vue&type=template&id=e64f0346&scoped=true"
import script from "./ContactsList.vue?vue&type=script&lang=js"
export * from "./ContactsList.vue?vue&type=script&lang=js"
import style0 from "./ContactsList.vue?vue&type=style&index=0&id=e64f0346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64f0346",
  null
  
)

export default component.exports